import i18n, { TFunction } from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationEN from "../public/locales/en/translation.json";
import translationFR from "../public/locales/fr/translation.json";
import translationPL from "../public/locales/pl/translation.json";
import contentBankEN from "../public/locales/en/content-bank.json";
import contentBankFR from "../public/locales/fr/content-bank.json";
import contentBankPL from "../public/locales/pl/content-bank.json";
import countryEN from "../public/locales/en/country.json";
import countryFR from "../public/locales/fr/country.json";
import countryPL from "../public/locales/pl/country.json";
import languageEN from "../public/locales/en/language.json";
import languageFR from "../public/locales/fr/language.json";
import languagePL from "../public/locales/pl/language.json";

const resources = {
  en: {
    translation: {
      ...translationEN,
      games: { ...(translationEN as { games?: object }).games, contentBank: contentBankEN },
    },
    country: countryEN,
    language: languageEN,
  },
  fr: {
    translation: {
      ...translationFR,
      games: { ...(translationFR as { games?: object }).games, contentBank: contentBankFR },
    },
    country: countryFR,
    language: languageFR,
  },
  pl: {
    translation: {
      ...translationPL,
      games: { ...(translationPL as { games?: object }).games, contentBank: contentBankPL },
    },
    country: countryPL,
    language: languagePL,
  },
};

const initI18n = (): Promise<TFunction> => {
  return i18n
    .use(detector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "en",
      keySeparator: ".",
      interpolation: {
        escapeValue: false,
      },
    });
};

export default initI18n;
